// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"c33c3137","433":"163988e2"}[chunkId] + ".chunk.js";
};